module.exports = __webpack_public_path__ + "img/1498460402.bd8bee63.jpg";